import { render } from "./BifurcatedBody.vue?vue&type=template&id=bbe4a576&scoped=true"
import script from "./BifurcatedBody.vue?vue&type=script&lang=js"
export * from "./BifurcatedBody.vue?vue&type=script&lang=js"

import "./BifurcatedBody.vue?vue&type=style&index=0&id=bbe4a576&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bbe4a576"

export default script